import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import { toast } from 'react-toastify';

import TopBar from '../../core/widgets/ui/TopBar';

import ComponentCardCount from './components/card/ComponentCardCount';
import ComponentExpiredSubList from './components/list/ComponentExpiredSubList';
import ComponentRenewalList from './components/list/ComponentRenewalList';

import ServiceOverview from 'services/serviceOverview';

export default function PanelHome() {

    const [doc, setDoc] = useState([]);

    const [loading, setLoading] = useState(true);

    const aggService = new ServiceOverview();

    const loadData = () => {
        (async function () {
            var res = await aggService.getOverView({}, '');
            if (res['status']) {
                setDoc(res.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <ScrollArea className="w-full h-full py-3 px-3">
            <div className="grid grid-cols-12 grid-gap-2">
                <div className="col-span-12 mt-2">
                    <div class="intro-y flex items-center justify-between h-10 border-b pb-4">
                        <h2 class="text-2xl font-medium truncate ml-2">
                            Overview
                        </h2>
                        <TopBar />
                    </div>
                    <div class="w-full h-full">
                        <div className="grid grid-cols-4 lg:grid-cols-10 mt-6 mb-5 gap-2 xl:gap-5 ml-2">
                            <ComponentCardCount bg="border-green-600" head="Total Subscription" count={doc.subs} disc="Total subscriptions done." loading={loading} />
                            <ComponentCardCount bg="border-prime" head="Total Restaurants" count={doc.orgs} disc="Total restaurants profiles." loading={loading} />
                            <ComponentCardCount bg="border-prime" head="Total Transactions" count={doc.trn} disc="Total transactions done." loading={loading} />
                            <ComponentCardCount bg="border-yellow-600" head="Total Staff" count={doc.staff} disc="Total admin staff." loading={loading} />
                            <ComponentCardCount bg="border-blue-600" head="Total Users" count={doc.users} disc="Total profiles of user / customers." loading={loading} />
                        </div>
                        <div className='grid grid-cols-4 lg:grid-cols-12 mt-6 mb-5 gap-2 xl:gap-5 ml-2'>
                            <ComponentRenewalList title="Upcoming Renewal" />
                            <ComponentExpiredSubList title="Nearbuy Expired" />
                        </div>
                        <div className='grid grid-cols-4 lg:grid-cols-12 mt-6 mb-5 gap-2 xl:gap-5 ml-2'></div>
                    </div>
                </div>
            </div>
        </ScrollArea >
    )
}
